import {useEffect, useState, useContext} from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from 'components/ProtectedRoute/ProtectedRoute';
import { DataContext } from 'contexts/DataContext';
import Login from 'pages/Login/Login';
import NotFound from 'pages/NotFound/NotFound';
import { routes as routeList} from "routes";

const AppRouter = () => {
    const [routes, setRoutes] = useState([] as any);
    const dataContext = useContext(DataContext);
    useEffect(() => {
        if(dataContext.loading) return;
        setRoutes(routeList);
    }, [dataContext.loading, dataContext.currentOrganization, dataContext.currentAssessment]);

    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path='/home' element={ <Navigate to="/tenant-executive-view" /> }/>
            <Route path='/' element={ <Navigate to="/tenant-executive-view" /> }/>

            {routes.map((routeGroup:any) => {
            if(!routeGroup.condition || routeGroup.condition()) {
                return routeGroup.values.map((route:any) => {
                if(!route.condition || route.condition()) {
                    return (
                        <Route key={route.name} path={route.path} element={route.protected ? <ProtectedRoute>{route.element}</ProtectedRoute> : <>{route.element}</>} />
                    )
                } else {
                    return false;
                }
                })
            } else {
                return false;
            }
            })}

            <Route path="*" element={<NotFound />} />
      </Routes>
    );
}
export default AppRouter;
